import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useSnackbar } from "../../common/snackbar/useSnackbar";
import { patchQuote } from "../actions/patchQuote.action";


export const usePatchQuoteStatus = () => {
    const queryClient = useQueryClient();
    const { showSnackbar } = useSnackbar();

    const mutation = useMutation({
        mutationFn: ({ quoteId, data }: { quoteId: number; data: any }) => patchQuote(quoteId, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["quotes"] });
            showSnackbar("Quote status updated successfully", "success");
        },
        onError: (error) => {
            showSnackbar(error.message, "error");
        },
    });

    return mutation;
}
